import { APIs } from "../constants/Constants";
import api from "./api";

export default class ActiveUsersAPI {
  getActiveUsers() {
    return api.get(APIs.SESSION.GET_ACTIVE_USERS);
  }
}
